var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '../../dom';
import { CheckBox } from '../CheckBox/CheckBox';
import './CheckBoxWithIcon.less';
var CheckBoxWithIcon = /** @class */ (function (_super) {
    __extends(CheckBoxWithIcon, _super);
    function CheckBoxWithIcon(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'CheckBoxWithIcon';
        _this.onChange = function (checked) {
            _this.toggleClassName('&_checked', checked);
            _this.props.onChange(checked);
        };
        _this.el = _this.DIV("& ".concat(props.className), [
            _this.DIV('&__icons', [props.iconOn, props.iconOff]),
            new CheckBox({ checked: props.checked, onChange: _this.onChange }),
        ]);
        _this.toggleClassName('&_checked', props.checked);
        return _this;
    }
    return CheckBoxWithIcon;
}(Component));
export { CheckBoxWithIcon };
